import { render, staticRenderFns } from "./ContentPlaceholder.vue?vue&type=template&id=69ba9ca7&"
import script from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ContentPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports